module.exports = __webpack_public_path__ + "media/images/favicon/android-icon-48x48-3ee08ebc008a94430106cbd220eebb31.png";